import { AccountManagerApp } from './AccountManagerApp';
import { registerReactWebComponent } from '@/core/utils/webComponent';

const extractAccountManagerProps = (element) => {
  const params = new URLSearchParams(globalThis.location?.search || '');

  return {
    accountId: element.getAttribute('account-id') || params.get('accountId') || undefined,
  };
};

export const registerAccountManagerComponent = () => {
  registerReactWebComponent('content-account-data-contract', AccountManagerApp, extractAccountManagerProps);
};
